import React from "react";

const MainFAQ = ({ questions }) => {
  return (
    <>
      <section className="text-gray-700">
        <div className="container px-5 mx-auto">
          <div className="text-center mb-20">
            <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
              Frequently Asked Question
            </h1>
            <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
              The most common questions about how our business works and what
              can do for you.
            </p>
          </div>
          <div className="accordion accordion-flush max-w-[950px] mx-auto relative">
            {questions.map((elem) => (
              <div key={elem.Id} className="accordion-item my-7 ">
                <h2 className="accordion-header" id={`flush-${elem.id}`}>
                  <button
                    className="accordion-button collapsed bg-[#CCE5FF] font-workSans font-[600]"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-${elem.Id}`}
                    aria-expanded="false"
                    aria-controls={`flush-${elem.Id}`}
                  >
                    {elem.Question}
                  </button>
                </h2>
                <div
                  id={`flush-${elem.Id}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`flush-${elem.id}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body text-sm font-workSans text-red-600">
                    {elem.Answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MainFAQ;
